/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Soyun Lee (sylee2@rsupport.com)
 *
 * @description
 *
 * @created at Wed Sep 04 2024
 **/
/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Soyun Lee (sylee2@rsupport.com)
 *
 * @description
 *
 * @created at Wed Sep 04 2024
 **/
/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Fri Apr 12 2024
 **/
import { Typography } from "@/frameworks/designStuff/components";
import { _T, _P } from "@rfice/language";

import allowImg from "./src/assets/images/img_allow_permission.png";
import * as S from "./emotion";

export default function AllowPermissionModal() {
	return (
		<S.AllowPermissionWrapper horizonAlign="center">
			<S.AllowImg src={allowImg} />
			<Typography typoSize="Head3" typoColor="neutral_80_100" style={{ marginBottom: "10px", marginTop: "54px" }}>
				{_T("허용 클릭")}
			</Typography>
			<Typography typoSize="Title2" typoColor="neutral_70_100">
				{_P("원할한 서비스 사용을 위해<br>카메라 / 마이크 사용을 허용해주세요.")}
			</Typography>
		</S.AllowPermissionWrapper>
	);
}
